<template>
  <router-link v-if="to" :to="to" class="ai-chat-card">
    <div class="ai-chat-card__type">{{ typeLabel }}</div>
    <div class="ai-chat-card__title">{{ item.title || item.canonical_id }}</div>
  </router-link>
  <div v-else class="ai-chat-card ai-chat-card--static">
    <div class="ai-chat-card__type">{{ typeLabel }}</div>
    <div class="ai-chat-card__title">{{ item.title || item.canonical_id }}</div>
  </div>
</template>

<script>
import { routeForContentReference } from '@/services/aiChatApi';

const TYPE_LABELS = {
  workout: 'Workout',
  article: 'Artikel',
  // CMS PlaylistPages are shown as Workouts in the product UI
  playlist: 'Workout',
};

export default {
  name: 'AiChatContentCard',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    to() {
      return routeForContentReference(this.item);
    },
    typeLabel() {
      const type = (this.item.type || '').toLowerCase();
      if (TYPE_LABELS[type]) return TYPE_LABELS[type];
      const id = String(this.item.canonical_id || '');
      const prefix = id.split(':')[0];
      return TYPE_LABELS[prefix] || 'Inhalt';
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-chat-card {
  display: block;
  padding: 14px 16px;
  border-radius: 12px;
  background: #fff;
  color: inherit;
  text-decoration: none;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

  &--static {
    cursor: default;
  }

  &__type {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    opacity: 0.55;
    margin-bottom: 6px;
  }

  &__title {
    font-size: 15px;
    font-weight: 600;
    line-height: 1.35;
  }
}
</style>
